var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[_c('router-view')],1),_c('v-snackbar',{attrs:{"top":"","color":"#0080aa"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.txt)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }